import React, { useState } from 'react';
import clsx from 'clsx';
import { CssBaseline, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Routes from '../../Routes';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.white,
        display: 'flex',
        flexDirection: 'column',
        // height: '100vh',
        // padding: theme.spacing(2)
    },

    shiftContent: {
        paddingLeft: 0
    },

    appBar: {
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
        zIndex: theme.zIndex.drawer + 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
            [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },

    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,

    drawerPaper: {
        width: drawerWidth,
        flexShrink: 0,
        
    },
    content: {
        // flexGrow: 1,
        height: '100%',
        // padding: theme.spacing(3),
        // [theme.breakpoints.up('md')]: {
        //     paddingLeft: '240px',
        // },
    },

    divider: {
        margin: theme.spacing(2, 0)
    },
    
    nav: {
        marginBottom: theme.spacing(2)
    },

    title: {
        flexGrow: 1
    },

    link: {
        textDecoration: 'none',
        color: theme.palette.text.primary,

    }    

}));


export default function Content() {

    const classes = useStyles();
    const theme = useTheme();
    // const [mobileOpen, setMobileOpen] = React.useState(false);

	// const handleDrawerToggle = () => {
    //         setMobileOpen(!mobileOpen);
    // };

    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
      });
    
      const [openSidebar, setOpenSidebar] = useState(false);
    
      const handleSidebarOpen = () => {
        setOpenSidebar(true);
      };
    
      const handleSidebarClose = () => {
        setOpenSidebar(false);
      };

      const shouldOpenSidebar = isDesktop ? true : openSidebar;

    return (
        <div 
            className={clsx({ 
                [classes.root]: true,
                [classes.shiftContent]: isDesktop
          })}
        >
            <CssBaseline/>
            
            <Routes/>
        </div>
    )
}
